import React from 'react';
import '../../Animation.css';

const User = () => {
  return (
    <>
      <div class="container animeDown">
        <div class="animation">
          <div class="one spin-one"></div>
          <div class="two spin-two"></div>
          <div class="three spin-one"></div>
        </div>
        <h2 class="uppercase">This page is still under construction</h2>
      </div>
    </>
  );
};

export default User;
